import { render } from "./ListPartnersView.vue?vue&type=template&id=a2b7ba5c"
import script from "./ListPartnersView.vue?vue&type=script&lang=js"
export * from "./ListPartnersView.vue?vue&type=script&lang=js"

import "./ListPartnersView.vue?vue&type=style&index=0&id=a2b7ba5c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__